var render = function render(){var _vm=this,_c=_vm._self._c;return _c('survey-calculator',{attrs:{"background-color":"#FFFFFF","template-id":"OpinionSurvey"}})
}
var staticRenderFns = []

export { render, staticRenderFns }